import update from 'react-addons-update';

var intialFormValue = {
  form: '',
  mainForm: {
    addonName: '',
    addonType: '',
    values: ''
  },
  insideForm: {
    addonName: '',
    addonType: 'addon',
    values: ''
  },
  activeField: {
    fieldName: '',
    rfieldIndex: '',
    addonName: '',
    addonIndex: '',
    riFieldName: ''
  }
};

const sppbForm = (state = intialFormValue, action) => {

    switch ( action.type ) {

        case 'ADD_EDIT_ADDON_IN':

            var newData = update( state, {
              form : { $set : 'insideForm' },
              insideForm  : {
                  addonName   : { $set : action.addonName },
                  values      : { $set : action.values }
              },
              activeField : {
                  addonName   : { $set : action.addonName },
                  riFieldName : { $set : action.riFieldName },
                  addonIndex  : { $set : action.addonIndex }
              }
            });

            return newData;

        case 'INIT_VALUE':
            var newData = update( state, {
              mainForm : {
                addonName : { $set : action.addonName },
                addonType : { $set : action.addonType },
                values    : { $set : action.values }
              },
              form : { $set : 'mainForm' }
            });

            return newData;

        // case 'SAVE_ADDON_IN':
        // case 'UPDATE_ADDON_IN':
        case 'CANCEL_ADDON_IN_FORM':
            return update( state, { form : { $set : 'mainForm' } });

        case 'ADD_EDIT_REPEAT_FIELD':
            return update( state, {
              activeField : {
                fieldName   : { $set : action.fieldName },
                rfieldIndex : { $set : action.rfieldIndex }
              }
            });

        default:
          return state
    }
}

export default sppbForm;



// WEBPACK FOOTER //
// ./src/helpers/form/reducers/sppbForm.js